import styled from 'styled-components';

import { Icon } from '@/ui/Icon';
import { Button } from '@/ui/Button';
import { formatToHoursAndMinutesFromSeconds } from '@/utils/time';
import { makeNamespacedComponent } from '@/ui/utils/makeNamespacedComponent';
import { Skeleton } from '@/ui/Skeleton';
import { obligatoryItemsLabel } from '@/features/journey/admin/utils/obligatoryItemsLabel';

const RootStyled = styled.div`
  padding: 32px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TitleStyled = styled.p`
  ${({ theme }) => theme.typography.title3};
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

const MetaBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const MetaItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconStyled = styled(Icon)`
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

const MetaLabelStyled = styled.div`
  ${({ theme }) => theme.typography.subheadline};
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

type JourneyViewOverviewBoxProps = {
  requiredItemsCount?: number;
  totalEffort?: number;
  onJoin: () => void;
};

const JourneyViewOverviewBox = ({ requiredItemsCount, totalEffort, onJoin }: JourneyViewOverviewBoxProps): React.ReactElement => {
  const showCompletionInvestTime = totalEffort !== undefined;
  const showRequiredItemsCount = !showCompletionInvestTime;

  return (
    <RootStyled>
      <TitleStyled>Overview</TitleStyled>
      <MetaBlockStyled>
        {showRequiredItemsCount && (
          <MetaItemStyled>
            <IconStyled icon={['far', 'route']} />
            <MetaLabelStyled>{obligatoryItemsLabel(requiredItemsCount ?? 0)}</MetaLabelStyled>
          </MetaItemStyled>
        )}
        {showCompletionInvestTime && (
          <MetaItemStyled>
            <IconStyled icon={['far', 'clock']} />
            <MetaLabelStyled>{formatToHoursAndMinutesFromSeconds(totalEffort)} total</MetaLabelStyled>
          </MetaItemStyled>
        )}
      </MetaBlockStyled>
      <Button onClick={onJoin} variant="primary">
        Join
      </Button>
    </RootStyled>
  );
};

const LoadingState = () => <Skeleton height={250} />;

const _JourneyViewOverviewBox = makeNamespacedComponent(JourneyViewOverviewBox, {
  LoadingState,
});

export { _JourneyViewOverviewBox as JourneyViewOverviewBox };
